import type { JSX } from 'preact';

export type DataAttributes = {
  timeZone?:
    | ''
    | 'America/Chicago'
    | 'America/Denver'
    | 'America/Los_Angeles'
    | 'America/New_York'
    | 'America/Phoenix';
};

export const Events = {
  input: handleInput,
};

export function getDataAttributes({ timeZone }: DataAttributes) {
  return {
    'data-time-zone': timeZone,
  };
}

const LOCAL_OPTIONS = {
  timeZoneName: 'longOffset',
} as const;

function getTimeZoneOffset(parts) {
  return parts.find((part) => part.type === 'timeZoneName').value.replace('GMT', '') || '0:00';
}

function handleInput(e: JSX.TargetedEvent<HTMLInputElement>) {
  const { currentTarget } = e;
  const { nextElementSibling, value } = currentTarget;
  const hiddenField = nextElementSibling as HTMLInputElement;
  const { timeZone } = currentTarget.dataset;

  if (!value) {
    hiddenField.value = '';
    return;
  }

  const localDate = new Date(value);

  const localFormatter = new Intl.DateTimeFormat('en-US', LOCAL_OPTIONS);
  const targetFormatter = new Intl.DateTimeFormat('en-US', {
    ...LOCAL_OPTIONS,
    timeZone: timeZone || undefined,
  });
  const localParts = localFormatter.formatToParts(localDate);
  const targetParts = targetFormatter.formatToParts(localDate);

  const localOffset = getTimeZoneOffset(localParts);
  const targetOffset = getTimeZoneOffset(targetParts);

  const [localHours, localMinutes] = localOffset.split(':').map(Number);
  const [targetHours, targetMinutes] = targetOffset.split(':').map(Number);

  const hoursDiff = localHours - targetHours;
  const minutesDiff = localMinutes - targetMinutes;
  const totalMinutesDiff = hoursDiff * 60 + minutesDiff;

  const targetDate = new Date(localDate);
  targetDate.setMinutes(targetDate.getMinutes() + totalMinutesDiff);

  hiddenField.value = targetDate.toISOString();
}
